import {
  collectFP,
  collectFCP,
  collectLCP,
  collectDNSQueryTime,
  collectTCPConnectTime,
  collectRequestTime,
  collectParseDOMTree,
  collectWhiteTime,
  collectDOMReadyTime,
  collectLoadTime
} from './utils/performance'
import { monitorXHRRequest, monitorFetchRequest } from './utils/request'
import { getResources } from './utils/resource'
import { getUserIp, getNativeBrowserInfo } from './utils/clientInfo'
import { getJavaScriptError, getJavaScriptAsyncError } from './utils/error'
import { clickEvent } from './utils/domChange'
import * as trackEvect from './utils/trackEvent'

export const initConfig = {
  appCode: null,
  global: true,
  collect: ['request', 'client'],
  intervalTime: 30 * 1000
}

export class Track {
  constructor (options = {}) {
    Object.assign(this, { ...initConfig, ...options, ...trackEvect })
    this.initTrack()
  }

  resetData () {
    this.performance = {}
    this.xhrRequestResList = []
    this.fetchRequestResList = []
    this.resourceList = {}
    this.clientInfo = {}
    this.errorList = []
    this.clickEventList = []
  }

  initTrack () {
    console.log('🚀 init colletion')
    if (this.global) {
      this.onload(() => {
        this.resetData()
        this.startCollect()
        this.sendLog()
      })
    }
  }

  onload (callback) {
    if (document.readyState === 'complete') {
      callback && callback()
    } else {
      window.onload = callback
    }
  }

  sendLog () {
    this.sendInterval = setInterval(() => {
      this.sendTrack('global', this.collectData())
    }, this.intervalTime)
  }

  destroySend () {
    if (this.sendInterval) {
      clearInterval(this.sendInterval)
    }
  }

  collectData () {
    const res = {}
    for (const i in this.collect) {
      const keys = this.collect[i]
      if (keys === 'performance') res.performance = this.performance
      if (keys === 'request') {
        res.xhrRequestResList = this.xhrRequestResList
        res.fetchRequestResList = this.fetchRequestResList
      }
      if (keys === 'resource') res.resourceList = this.resourceList
      if (keys === 'client') res.clientInfo = this.clientInfo
      if (keys === 'error') res.errorList = this.errorList
      if (keys === 'clickEvent') res.clickEventList = this.clickEventList
    }
    return res
  }

  async collectPerformance () {
    const fp = await collectFP()
    const fcp = await collectFCP()
    const lcp = await collectLCP()
    const domReadyTime = await collectDOMReadyTime()
    const loadTime = await collectLoadTime()
    const dnsQueryTime = collectDNSQueryTime()
    const tcpConnectTime = collectTCPConnectTime()
    const requestTime = collectRequestTime()
    const parseDOMTreeTime = collectParseDOMTree()
    const whiteTime = collectWhiteTime()
    const result = {
      fp,
      fcp,
      lcp,
      dnsQueryTime,
      tcpConnectTime,
      requestTime,
      parseDOMTreeTime,
      whiteTime,
      domReadyTime,
      loadTime
    }
    this.performanceData = result
    return result
  }

  collectRequest () {
    monitorXHRRequest((res) => {
      this.xhrRequestResList = [...this.xhrRequestResList, res]
      if (!this.global) {
        this.sendRequestLog({ xhrRequestResList: [res] })
      }
    })
    monitorFetchRequest((res) => {
      this.fetchRequestResList = [...this.fetchRequestResList, res]
    })
  }

  collectResources () {
    const resourceList = getResources()
    this.resourceList = resourceList
  }

  collectClick () {
    clickEvent((res) => {
      this.clickEventList = [...this.clickEventList, res]
    })
  }

  collectClinetInfo = async () => {
    const userIp = await getUserIp()
    const nativeBrowserInfo = getNativeBrowserInfo()
    const clientInfo = { ...userIp, ...nativeBrowserInfo }
    this.clientInfo = clientInfo
    return userIp
  };

  collectError () {
    getJavaScriptError((res) => {
      this.errorList = [...this.errorList, res]
    })
    getJavaScriptAsyncError((res) => {
      this.errorList = [this.errorList.res]
    })
  }

  trackWork (type) {
    const orign = window.history[type]
    return (...args) => {
      const orignReulst = orign.apply(this, args)
      const e = new Event(type)
      e.arguments = args
      window.dispatchEvent(e)
      return orignReulst
    }
  }

  sendTrack (eventType, body) {
    const data = body || {}
    fetch(this.url, {
      method: 'post',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        appCode: this.appCode,
        eventType,
        actionTime: Date.now(),
        userInfo: this.userInfo(),
        ...data
      })
    }).then(res => {
      this.resetData()
      return res.json()
    })
  }

  startCollect () {
    for (const i in this.collect) {
      const keys = this.collect[i]
      keys === 'client' && this.collectClinetInfo()
      keys === 'performance' && this.collectPerformance()
      keys === 'request' && this.collectRequest()
      keys === 'resoures' && this.collectResources()
      keys === 'error' && this.collectError()
      keys === 'click' && this.collectClick()
    }
  }
}
